import { getLeavesAloneWeekdays } from "@/features/home/leavesAlone";

/** ISO weekdays shown in the leave-days picker (Mon–Fri). */
export const SCHOOL_WEEKDAYS = [1, 2, 3, 4, 5] as const;

/**
 * Pipedrive "Not allowed" option id.
 * Written when no weekday is selected. Must match s4p-server parentContactCache.
 */
export const LEAVES_ALONE_NOT_ALLOWED_OPTION_ID = 128;

/**
 * ISO weekday (Mon=1 … Fri=5) → Pipedrive Leaves Alone option id.
 * Inverse of LEAVES_ALONE_OPTION_TO_ISO_WEEKDAY in s4p-server parentContactCache.
 */
export const ISO_WEEKDAY_TO_LEAVES_ALONE_OPTION_ID: Record<number, number> = {
    1: 123,
    2: 124,
    3: 125,
    4: 126,
    5: 127,
};

/**
 * Pipedrive Leaves Alone option ids for a profile PATCH.
 * An empty weekday list maps to "Not allowed".
 */
export function toLeavesAloneOptionIds(weekdays: number[]): number[] {
    const optionIds = getLeavesAloneWeekdays(weekdays)
        .map((day) => ISO_WEEKDAY_TO_LEAVES_ALONE_OPTION_ID[day])
        .filter((id): id is number => id != null);

    return optionIds.length === 0
        ? [LEAVES_ALONE_NOT_ALLOWED_OPTION_ID]
        : optionIds;
}

/** Adds or removes a school weekday from the current selection. */
export function toggleSchoolWeekday(
    weekdays: number[],
    day: number,
): number[] {
    const current = getLeavesAloneWeekdays(weekdays);
    if (ISO_WEEKDAY_TO_LEAVES_ALONE_OPTION_ID[day] == null) {
        return current;
    }

    const next = current.includes(day)
        ? current.filter((item) => item !== day)
        : [...current, day];

    return getLeavesAloneWeekdays(next);
}
